export default {
    level: 9,
    time: false,
    filters: [
        // "API/*"
    ],
}